import React from 'react';

import { getIn } from '@gogame/form';

import { useGroup } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Group';

import { ValidationContext } from '../ValidationContext';

export const useValidationErrorsByResolveName = (name = '') => {
  const values = React.useContext(ValidationContext);
  const { getResolveName } = useGroup();
  const resolveName = getResolveName(name);
  return getIn(values, resolveName);
};
